import React from "react";
import CustomTable from "../../utils/commonComponent/CustomAntTable";
import { Button, Col, Image, Row } from "react-bootstrap";

import { connect } from "react-redux";
import { BaseReactComponent } from "../../utils/form";
import editIcon from '../../assets/images/edit-icon.svg'
import deleteIcon from '../../assets/images/delete-icon.svg'
import { ALT_THUMBNAIL, API_LIMIT, MODULE_ID_MAP, START_PAGE, isModuleExist } from "../../utils/Constant";
import { InformationModal, ComponentHeader, VerifiedModal, Spinner } from "../common";
import { deleteAuthCommonApi, getAllContentApi, getAllContentFilterApi } from "./Api";
import editPencil from "../../assets/images/edit-icon.png";
import { toast } from "react-toastify";
import { replaceHistory } from "../../utils/ReusableFunctions";
import { CONTENT_VERIFY } from "../../utils/urls";
import FilterVefiedDropDown from "../common/FilterVefiedDropDown";
import { withRouter } from "../../utils/hoc/withRouter";
import AdvancedTable from "../../utils/commonComponent/CustomAntTable";
import { Tag } from "antd";
import OptionsDropdown from "../../utils/commonComponent/OptionsDropdown";
class ContentType extends BaseReactComponent {
  constructor(props) {
    super(props);
    const AccesData = isModuleExist(MODULE_ID_MAP.ContentContent);
    this.state = {
      access: AccesData,
      search: "",
      dummyData: [],
      searchResult: [],
      pageSize: API_LIMIT,
      currentPage: START_PAGE,
      delete: false,
      deleteData: {},
      editData: "",
      showEdit: false,
      isLoading: true,

      isVerify: false,
      show: false,

      verified: '',
      verifyUrl: ''
    };
  }

  componentDidMount() {
    const { history } = this.props;
    history({
      pathname: this.props.location.pathname,
      search: `?p=${this.state.currentPage || START_PAGE}`,
    });
    this.props.getAllContentApi(this);
    getAllContentFilterApi(this);
  }

  componentDidUpdate(prevProps, prevState) {
    const prevParams = new URLSearchParams(prevProps.location.search);
    const prevPage = parseInt(prevParams.get("page"), 10) || START_PAGE;
    const prevSearch = prevParams.get("search") || "";
    const prevVerified = prevParams.get("isVerified") || "";

    const params = new URLSearchParams(this.props.location.search);
    const page = parseInt(params.get("page"), 10) || START_PAGE;
    const search = params.get("search") || "";
    const verified = params.get("isVerified") || "";

    if (prevParams.toString() !== params.toString()) {
      this.setState({ currentPage: page, search }, () => {
        this.props.getAllContentApi(this);
      });
    }
  }
  onChangeMethod = (value) => {
    this.setState({ searchText: value.search, currentPage: START_PAGE }, () => {
      replaceHistory(this.props.history, START_PAGE, value.search);
    })
  };
  clearSearch = () => {
    this.onChangeMethod({ search: "" });
  }
  getDetailsUser = (id) => {
    this.props.history({ pathname: `/ads-customer-details/${id}`, state: { "id": id } });
  }


  showEditModal = (rowData = null) => {
    this.props.history({ pathname: "/content/add-content", state: { id: rowData.uuid } });
    // this.setState({
    //   showEdit: !this.state.showEdit,
    //   editData: rowData,
    // });
  };
  openCloseDeleteModal = (rowData) => {
    this.setState({
      delete: !this.state.delete,
      deleteData: rowData,
    });
  };
  deleteHandle = async (id) => {
    const res = await deleteAuthCommonApi(`content/${id}`);
    // console.log(res)
    if (res.status === 200) {
      this.props.getAllContentApi(this);
      this.setState({
        delete: !this.state.delete
      });
      // toast.success("Successfully Deleted.")
    } else {
      toast.error("Somthis wrong...")
    }
    // deleteAmcApi(id, this, this.openCloseDeleteModal) updat this
  }
  getDetailsUser = (id) => {
    this.props.history({ pathname: `/content-details/${id}`, state: { "id": id } });
  }
  render() {
    const { dummyData, search, serchResult, tabName, activeTab, access, isLoading, filterData } = this.state;
    const { contentList, totalPages, currentPage } = this.props.contentState;
    console.log(filterData);
    return (
      <>
        {this.state.delete && (
          <InformationModal
            show={this.state.delete}
            id={this.state.deleteData.uuid}
            title={`Are you sure you want to delete ${this.state.deleteData.title}?`}
            handleClose={this.openCloseDeleteModal}
            handleDelete={this.deleteHandle}
          />
        )}
        <VerifiedModal
          // name={`this '${this.state.editData?.campaignName}' campaign.`}
          name={`'${this.state.editData?.title}'`}
          show={this.state.show}
          url={CONTENT_VERIFY + `/${this.state?.editData?.uuid}`}
          isVerified={this.state.isVerify}
          handleCancel={() => { this.setState({ show: false }) }}
          successRes={() => { this.props.getAllContentApi(this) }}
        />
        <section className="request-section">
          <ComponentHeader
            breadcrumb={[["Content", ""]]}
            isSearch={true}
            placeholder={"Search Content"}
            onChangeMethod={this.onChangeMethod}
            clearSearch={() => this.clearSearch()}
            primaryBtn="Add Content"
            handlePrimaryBtn={() => {
              this.props.history("/content/add-content");
            }}
            filterOptions={convertToFilterOptions(this.state?.filterData || [])}
            ctx={this}
          />
          {/* <div className="">
            <Row>
              <Col sm={2}>
                <FilterVefiedDropDown ctx={this} />
              </Col>
            </Row>
          </div> */}
          <div className="commom-table-wrapper">
            <AdvancedTable
              ctx={this}
              total={contentList?.length}
              data={isLoading ? [] : contentList?.list || []}
              columns={[
                {
                  width: 150,
                  title: "Title",
                  dataIndex: "title",
                  className: "name",
                  
                  isCell: true,
                  render: (text, rowData, dataIndex) => {
                    return rowData?.title || '';
                  },
                },
                {
                  width: access.verificationAccess ? 80 : 0,
                  title: "Verified",
                  dataIndex: "isVerified",
                  render: (text, rowData, dataIndex) => {
                    const color = rowData.isVerified ? 'green' : 'orange';
                    return <div className=" d-flex align-items-center inter-medium">
                      <Tag color={color}>{rowData.isVerified ? "YES" : "NO"}
                        <Image src={editPencil} onClick={() => this.setState({ show: true, isVerify: rowData.isVerified, editData: rowData })} className="edit-pencil-icon" alt="icon" />
                      </Tag>
                    </div>;
                  },
                },
                {
                  width: 120,
                  title: "AMC",
                  dataIndex: "amc",
                  className: "name",
                  render: (text, rowData, dataIndex) => {
                    return rowData?.amc?.amcName || ''
                  },
                },
                {
                  width: 150,
                  title: "Content Type",
                  dataIndex: "contentType",
                  className: "name",
                  isCell: true,
                  render: (text, rowData, dataIndex) => {
                    return rowData?.contentType?.contentTypeName || "";
                  },
                },
                {
                  width: 120,
                  title: "Thumbnail Image",
                  dataIndex: "thumbnail",
                  className: "",
                  isCell: true,
                  render: (text, rowData, dataIndex) => {
                    return (rowData.thumbnail ? <Image src={rowData.thumbnail} className="table-img" alt={ALT_THUMBNAIL} /> : "NA");

                  },
                },
                {
                  width: 150,
                  title: "Category",
                  dataIndex: "category",
                  className: "name",
                  isCell: true,
                  render: (text, rowData, dataIndex) => {
                    return rowData?.category?.categoryName || ''
                  },
                },

                {
                  width: 110,
                  title: "Updated By",
                  dataIndex: "updatedBy",
                  className: "name",
                  isCell: true,
                  render: (text, rowData, dataIndex) => {
                    return rowData?.updatedBy?.name || 'Na';;
                  },
                },
                {
                  width: 110,
                  title: "Created By",
                  dataIndex: "createdBy",
                  className: "name",
                  isCell: true,
                  render: (text, rowData, dataIndex) => {
                    return rowData?.createdBy?.name || 'Na';
                  },
                },
                {
                  width: 20,
                  title: "Action",
                  dataIndex: "",
                  fixed: 'right',
                  isCell: true,
                  render: (text, rowData, dataIndex) => {
                    return (
                      <>
                      <OptionsDropdown
                        viewHandler={() => this.getDetailsUser(rowData?.uuid)}
                        editHandler={access.updateAccess ? () => { this.showEditModal(rowData) } : null}
                        deleteHandler={access.deleteAccess ? () => { this.openCloseDeleteModal(rowData) } : null}
                      />
                      </>
                    );
                  },
                },
              ]}
              loading={this.state.isLoading}
            />
          </div>
        </section>
      </>
    );
  }
}


const mapStateToProps = (state) => ({
  contentState: state.ContentState,
});
const mapDispatchToProps = {
  getAllContentApi,
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ContentType));


export const convertToFilterOptions = (filterData) => {
  return filterData.map(group => {
    const base = {
      field: group.key,
      label: group.title || group.code,
    };

    switch (group.code) {

      case "TARGETED_CONTENT":
        return {
          ...base,
          field: "targetedContent",          // backend expects this parent list
          type: "group",
          groups: group.items.map(item => ({
            parent: item.title,              // e.g. "Risk Appetite"
            field: mapParentToBackendParam(item.title), 
            options: (item.types || []).map(type => ({
              value: type,
              label: type
            }))
          }))
        };

      // multi-select groups
      case "PREMIUM":
      case "SECTION":
      case "CONTENT_TYPE":
      case "LANGUAGE":
      case "CATEGORY":
        return {
          ...base,
          type: "multiple",
          options: group.items.map(item => ({
            value: item.title,
            label: item.title
          }))
        };

      case "CREATOR":
        return {
          ...base,
          type: "multiple",
          options: group.items.map(item => ({
            value: item.title,
            label: item.title
          }))
        };

      case "CUSTOMIZATION":
        return {
          ...base,
          type: "multiple",
          options: group.items.map(item => ({
            value: item.title,
            label: item.title,
            color: item.colorCode
          }))
        };

      default:
        return {
          ...base,
          type: "multiple",
          options: group.items?.map(item => ({
            value: item.title || item.uuid || item.code,
            label: item.title || item.languageName || item.categoryName || item.contentCreatorName
          })) || []
        };
    }
  });
};

// Backend param mapping
const mapParentToBackendParam = (title) => {
  const mapping = {
    "Financial Understanding": "financialUnderstanding",
    "Risk Appetite": "riskAppetide",
    "Goal": "goal",
    "Marital Status": "maritalStatus",
    "Income Group": "incomeGroup",
    "Age Group": "ageGroup",
    "Gender": "gender",
    "Employment Type": "employmentType",
    "Targeted Playlists": "targetedContents",
  };
  return mapping[title] || title;
};
